export const LANGUAGE_STORAGE_KEY = "rentduo_language_v1";

export const SUPPORTED_LANGUAGES = [
  { value: "en", label: "English" },
  { value: "es", label: "Español" },
];

export function normalizeLanguage(value = "") {
  return value === "es" ? "es" : "en";
}

const translations = {
  en: {
    about: "About",
    acceptContinue: "Accept & Continue",
    addCity: "Add your city",
    addProperty: "Add property",
    authSubtitle: "Blue trust. Green growth. Real rental transparency.",
    buildTrust: "Build trust",
    cancel: "Cancel",
    close: "Close",
    completeProfile: "Complete profile",
    completeProfilePrompt: "Complete your profile to build trust.",
    completeProfileText: "A complete profile makes users more likely to review, message, and trust you.",
    continue: "Continue",
    createFreeAccount: "Create Free Account",
    createProfile: "Create Profile",
    decline: "Decline",
    disclaimerAcceptLocked: "Scroll to the bottom to unlock Accept & Continue.",
    disclaimerAcceptReady: "You can now continue.",
    disclaimerExternalLinks: "8. External Links",
    disclaimerExternalLinksText:
      "RentDuo may link to government or third-party websites for reference. RentDuo is not responsible for the content, availability, or accuracy of any outside site.",
    disclaimerFairUse: "7. Fair Use & User Responsibility",
    disclaimerFairUseText:
      "By continuing, you agree to provide honest information, avoid false, abusive, threatening, discriminatory, defamatory, or illegal content, and accept responsibility for all activity under your account.",
    disclaimerLead:
      "Welcome to RentDuo. RentDuo is a user-driven platform where tenants, landlords, and property managers can share reviews, ratings, property information, and rental-related experiences.",
    disclaimerLiability: "4. Platform Liability Limitation",
    disclaimerLiabilityText:
      "To the fullest extent permitted by law, RentDuo is not responsible for disputes, damages, losses, rental decisions, property conditions, user conduct, or any actions taken based on information found in the app.",
    disclaimerModeration: "5. Moderation & Content Removal",
    disclaimerModerationText:
      "RentDuo may review, flag, limit, remove, or refuse content and may suspend accounts that violate platform rules, but this does not mean every harmful or inaccurate submission will be detected immediately.",
    disclaimerNoAdvice: "1. No Professional Advice",
    disclaimerNoAdviceText:
      "RentDuo does not provide legal, financial, real estate, or other professional advice. Content in the app is provided for general informational purposes only.",
    disclaimerNoGuarantee: "3. No Guarantee of Outcomes",
    disclaimerNoGuaranteeText:
      "RentDuo does not guarantee the quality of any landlord, tenant, property manager, property, listing, or rental outcome. Users must make their own decisions and perform their own due diligence.",
    disclaimerNotAffiliated: "RentDuo is not affiliated with any government agency or housing authority.",
    disclaimerReviewCarefully: "Please review this carefully before entering the app.",
    disclaimerTerms: "9. Acceptance of Terms",
    disclaimerTermsText:
      "By clicking Accept & Continue, you confirm that you have read and understood this disclaimer, that you will use RentDuo responsibly, and that you accept use of the platform at your own discretion and risk.",
    disclaimerTitle: "Disclaimer & User Acknowledgment",
    disclaimerUserContent: "2. User-Generated Content",
    disclaimerUserContentText:
      "Reviews, ratings, comments, claims, and profile information are submitted by users. RentDuo does not guarantee that all content is accurate, complete, current, or free from error.",
    disclaimerVerification: "6. Verification & Unverified Content",
    disclaimerVerificationText:
      "Some accounts, properties, or submissions may be marked as verified, unverified, or community added. Unverified material should be reviewed carefully and should not be treated as guaranteed fact.",
    feed: "Feed",
    findProperty: "Find property",
    home: "Home",
    language: "Language",
    leaveReview: "Leave review",
    login: "Login",
    logout: "Logout",
    markAllRead: "Mark all as read",
    manager: "Manager",
    messages: "Messages",
    myRentDuoProfile: "My RentDuo Profile",
    notifications: "Notifications",
    notificationEmpty: "No notifications yet. New messages, reviews, replies, and property activity will show here.",
    notificationLabel: "Open notifications",
    noMessagesYet: "No messages yet. Select a user profile and send the first message.",
    noPropertiesLinked: "No properties linked yet",
    noReviewsYet: "No reviews yet",
    profile: "Profile",
    profileSettings: "Profile settings",
    properties: "Properties",
    report: "Report",
    reportUser: "Report User",
    reviews: "Reviews",
    selectedProperty: "Selected Property",
    shareRentDuo: "Share RentDuo",
    signInTitle: "Sign in to RentDuo",
    signUp: "Sign Up",
    signUpTitle: "Create your RentDuo account",
    startHere: "Start here",
    startQuestion: "What do you want to do first?",
    startText:
      "Search a property, add a rental address, or leave your first rental review. This keeps new users from landing on an empty screen.",
    welcomeBack: "Welcome back",
    welcomeBackKicker: "Welcome back",
    writeReview: "Write a Review",
    starOnlyRating: "Star-only community rating.",
  },
  es: {
    about: "Acerca de",
    acceptContinue: "Aceptar y continuar",
    addCity: "Agrega tu ciudad",
    addProperty: "Agregar propiedad",
    authSubtitle: "Confianza azul. Crecimiento verde. Transparencia real para rentas.",
    buildTrust: "Genera confianza",
    cancel: "Cancelar",
    close: "Cerrar",
    completeProfile: "Completar perfil",
    completeProfilePrompt: "Completa tu perfil para generar confianza.",
    completeProfileText: "Un perfil completo ayuda a que otros usuarios te revisen, te escriban y confíen en ti.",
    continue: "Continuar",
    createFreeAccount: "Crear cuenta gratis",
    createProfile: "Crear perfil",
    decline: "Rechazar",
    disclaimerAcceptLocked: "Desplázate hasta el final para activar Aceptar y continuar.",
    disclaimerAcceptReady: "Ya puedes continuar.",
    disclaimerExternalLinks: "8. Enlaces externos",
    disclaimerExternalLinksText:
      "RentDuo puede enlazar a sitios gubernamentales o de terceros como referencia. RentDuo no es responsable del contenido, disponibilidad o exactitud de sitios externos.",
    disclaimerFairUse: "7. Uso justo y responsabilidad del usuario",
    disclaimerFairUseText:
      "Al continuar, aceptas proporcionar información honesta, evitar contenido falso, abusivo, amenazante, discriminatorio, difamatorio o ilegal, y asumir responsabilidad por toda actividad en tu cuenta.",
    disclaimerLead:
      "Bienvenido a RentDuo. RentDuo es una plataforma impulsada por usuarios donde inquilinos, propietarios y administradores de propiedades pueden compartir reseñas, calificaciones, información de propiedades y experiencias relacionadas con rentas.",
    disclaimerLiability: "4. Limitación de responsabilidad de la plataforma",
    disclaimerLiabilityText:
      "En la medida máxima permitida por la ley, RentDuo no es responsable por disputas, daños, pérdidas, decisiones de renta, condiciones de propiedades, conducta de usuarios ni acciones tomadas con base en información encontrada en la app.",
    disclaimerModeration: "5. Moderación y eliminación de contenido",
    disclaimerModerationText:
      "RentDuo puede revisar, marcar, limitar, eliminar o rechazar contenido y puede suspender cuentas que violen las reglas de la plataforma, pero esto no significa que cada envío dañino o inexacto será detectado de inmediato.",
    disclaimerNoAdvice: "1. Sin asesoría profesional",
    disclaimerNoAdviceText:
      "RentDuo no brinda asesoría legal, financiera, inmobiliaria ni profesional. El contenido de la app se ofrece solo con fines informativos generales.",
    disclaimerNoGuarantee: "3. Sin garantía de resultados",
    disclaimerNoGuaranteeText:
      "RentDuo no garantiza la calidad de ningún propietario, inquilino, administrador, propiedad, anuncio o resultado de renta. Los usuarios deben tomar sus propias decisiones y hacer su propia revisión.",
    disclaimerNotAffiliated: "RentDuo no está afiliado con ninguna agencia gubernamental o autoridad de vivienda.",
    disclaimerReviewCarefully: "Revísalo cuidadosamente antes de entrar a la app.",
    disclaimerTerms: "9. Aceptación de términos",
    disclaimerTermsText:
      "Al hacer clic en Aceptar y continuar, confirmas que has leído y entendido este aviso, que usarás RentDuo responsablemente y que aceptas usar la plataforma bajo tu propio criterio y riesgo.",
    disclaimerTitle: "Aviso y reconocimiento del usuario",
    disclaimerUserContent: "2. Contenido generado por usuarios",
    disclaimerUserContentText:
      "Las reseñas, calificaciones, comentarios, reclamos e información de perfil son enviados por usuarios. RentDuo no garantiza que todo el contenido sea exacto, completo, actual o libre de errores.",
    disclaimerVerification: "6. Verificación y contenido no verificado",
    disclaimerVerificationText:
      "Algunas cuentas, propiedades o publicaciones pueden marcarse como verificadas, no verificadas o agregadas por la comunidad. El material no verificado debe revisarse cuidadosamente y no debe tratarse como hecho garantizado.",
    feed: "Actividad",
    findProperty: "Buscar propiedad",
    home: "Inicio",
    language: "Idioma",
    leaveReview: "Dejar reseña",
    login: "Iniciar sesión",
    logout: "Salir",
    markAllRead: "Marcar todo como leído",
    manager: "Administrador",
    messages: "Mensajes",
    myRentDuoProfile: "Mi perfil de RentDuo",
    notifications: "Notificaciones",
    notificationEmpty: "Aún no hay notificaciones. Aquí aparecerán mensajes, reseñas, respuestas y actividad de propiedades.",
    notificationLabel: "Abrir notificaciones",
    noMessagesYet: "Aún no hay mensajes. Selecciona un perfil de usuario y envía el primer mensaje.",
    noPropertiesLinked: "Aún no hay propiedades vinculadas",
    noReviewsYet: "Aún no hay reseñas",
    profile: "Perfil",
    profileSettings: "Configuración del perfil",
    properties: "Propiedades",
    report: "Reportar",
    reportUser: "Reportar usuario",
    reviews: "Reseñas",
    selectedProperty: "Propiedad seleccionada",
    shareRentDuo: "Compartir RentDuo",
    signInTitle: "Iniciar sesión en RentDuo",
    signUp: "Registrarse",
    signUpTitle: "Crea tu cuenta de RentDuo",
    startHere: "Empieza aquí",
    startQuestion: "¿Qué quieres hacer primero?",
    startText:
      "Busca una propiedad, agrega una dirección de renta o deja tu primera reseña. Esto evita que usuarios nuevos lleguen a una pantalla vacía.",
    welcomeBack: "Bienvenido de nuevo",
    welcomeBackKicker: "Bienvenido de nuevo",
    writeReview: "Escribir una reseña",
    starOnlyRating: "Calificación comunitaria solo con estrellas.",
  },
};

export function translate(language, key) {
  const normalized = normalizeLanguage(language);
  return translations[normalized]?.[key] || translations.en[key] || key;
}
